export enum OperationsEnum {
    eq ='eq',
    in ='in',
    like = 'like',
    ne = 'ne',
    nin = 'nin',
}
